module.exports = __webpack_public_path__ + "img/chuangsai_39.d7520855.jpg";